// extracted by mini-css-extract-plugin
export default {"container":"spinner_container__bpnTO","body":"spinner_body__Rh3Gj"};